import { TConfig } from '@@/auto/interfaces';

export default (): DeepPartial<TConfig> => ({});
